export const AUDIT_HISTORY_ACTIONS = {
  create: {
    id: 'create',
    label: 'label.CREATE'
  },
  custompurge: {
    id: 'custompurge',
    label: 'label.CUSTOM_PURGE'
  },
  delete: {
    id: 'delete',
    label: 'label.DELETE'
  },
  editfrontapp: {
    id: 'editfrontapp',
    label: 'label.EDIT_FRONTAPP'
  },
  editgoogle: {
    id: 'editgoogle',
    label: 'label.EDIT_GOOGLE'
  },
  editoutreach: {
    id: 'editoutreach',
    label: 'label.EDIT_OUTREACH'
  },
  login: {
    id: 'login',
    label: 'label.AUTH'
  },
  pushfrontapp: {
    id: 'pushgfrontapp',
    label: 'label.FRONTAPP_PUSH'
  },
  pushgoogle: {
    id: 'pushgoogle',
    label: 'label.GOOGLE_PUSH'
  },
  pusho365: {
    id: 'pusho365',
    label: 'label.M365_PUSH'
  },
  pushemail: {
    id: 'pushemail',
    label: 'label.SIGNATURE_REMINDER'
  },
  pushoutreach: {
    id: 'pushoutreach',
    label: 'label.OUTREACH_PUSH'
  },
  pushsalesforce: {
    id: 'pushsalesforce',
    label: 'label.SALESFORCE_PUSH'
  },
  syncsalesforceusers: {
    id: 'syncsalesforceusers',
    label: 'label.SYNC_SALESFORCE_USERS'
  },
  syncgappsgroups: {
    id: 'syncgappsgroups',
    label: 'label.SYNC_GOOGLE_GROUPS'
  },
  syncgappsorgs: {
    id: 'syncgappsorgs',
    label: 'label.SYNC_GOOGLE_ORGS'
  },
  syncgappsusers: {
    id: 'syncgappsusers',
    label: 'label.SYNC_GOOGLE_USERS'
  },
  syncbamboohrusers: {
    id: 'syncbamboohrusers',
    label: 'label.SYNC_BAMBOOHR_USERS'
  },
  synccalendlyusers: {
    id: 'synccalendlyusers',
    label: 'label.SYNC_CALENDLY_USERS'
  },
  synccsvusers: {
    id: 'synccsvusers',
    label: 'label.SYNC_CSV_USER'
  },
  synco365users: {
    id: 'synco365users',
    label: 'label.SYNC_O365_USERS'
  },
  synco365groups: {
    id: 'synco365groups',
    label: 'label.SYNC_O365_GROUPS'
  },
  syncmangoappsusers: {
    id: 'syncmangoappsusers',
    label: 'label.SYNC_MANGOAPPS_USERS'
  },
  syncfrontappusers: {
    id: 'syncfrontappusers',
    label: 'label.SYNC_FRONTAPP_USERS'
  },
  update: {
    id: 'update',
    label: 'label.UPDATE'
  },
  updateuser: {
    id: 'updateuser',
    label: 'label.UPDATE_USER'
  }
};
